<template>
  <ModalDialog
    v-bind="$attrs"
    v-on="$listeners"
    role="alertdialog"
  >
    <div class="d-flex flex-column align-items-center gap-3">
      <div class="bi bi-exclamation-triangle text-danger icon-flash-in status-icon"></div>
      <h4 class="text-danger">
        <slot></slot>
      </h4>

      <slot name="error-body"></slot>
    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/Modals/ModalDialog';

export default {
  components: { ModalDialog }
};
</script>

<style lang="scss" scoped>
@import "@/styles/animations";
</style>
